import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from '../core';
import { Toast } from '../shared';

@Component({
  selector: 'q-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit, OnDestroy {

  // #region VARIABLES GLOBALES
  subToasts: Subscription;
  toasts: Toast[];
  // #endregion

  // #region CONSTRUCTEUR
  constructor(
    private alert: AlertService,
  ) {}
  // #endregion

  // #region CYCLE DE VIE
  ngOnInit(): void {
    this.subToasts = this.alert.getToasts().subscribe((toasts: Toast[]): void => {
      this.toasts = toasts;
    });
  }

  ngOnDestroy(): void {
    this.subToasts.unsubscribe();
  }
  // #endregion

  // #region FONCTIONS PUBLIQUES
  public removeToast(toast: Toast): void {
    this.alert.removeToast(toast);
  }
  // #endregion

}
